import { IBaseCellsProps } from '../cells.interfaces';
import { StyledTableCell } from './CellIcon.styles';
import { Icon, useTheme, Theme } from '../../../base-components';

interface Props extends IBaseCellsProps {
    data: {
        iconName: string;
        iconColor: string;
        iconSize: number;
    };
}

const getIconColor = (color: string, theme: Theme) => {
    // Check if the color is a theme color name
    const themeColors = [
        'primary',
        'secondary',
        'info',
        'success',
        'warning',
        'error',
    ];
    if (themeColors.includes(color)) {
        return theme.palette[color as keyof typeof theme.palette].main;
    }
    // If not a theme color, return the color as is
    return color;
};

const CellIcon = (props: Props) => {
    const { alignment, columnIndex, stickyColumn, rowStickyWidths, data } =
        props;
    const theme = useTheme();
    return (
        <StyledTableCell
            alignment={alignment}
            columnIndex={columnIndex}
            rowStickyWidths={rowStickyWidths}
            stickyColumn={stickyColumn}
        >
            {data.iconName && (
                <Icon
                    name={data.iconName}
                    size={data.iconSize || 20}
                    color={
                        data.iconColor
                            ? getIconColor(data.iconColor)
                            : theme.palette.primary.main
                    }
                />
            )}
        </StyledTableCell>
    );
};

export default CellIcon;
